import SystemConfigForm from "../../components/views/system-config";

function SystemConfigPage() {
  return <SystemConfigForm />;
}

export default SystemConfigPage;
